import React, { useState, useEffect, useCallback } from 'react';
import { MapPin, Mail } from 'lucide-react';
import { contactInfo, services } from '../mockData';
import { useEditMode } from '../contexts/EditModeContext';
import { EditableText, EditableList } from './EditableComponents';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const Footer = () => {
  const { isEditMode } = useEditMode();
  const [brands, setBrands] = useState([]);

  const loadBrands = useCallback(async () => {
    try {
      const settingsRes = await axios.get(`${API}/settings`);
      if (Array.isArray(settingsRes.data.footer_brands)) {
        setBrands(settingsRes.data.footer_brands);
        return;
      }
      const response = await axios.get(`${API}/products`);
      const uniqueBrands = [...new Set(response.data.map(p => p.brand))].sort();
      setBrands(uniqueBrands);
    } catch (error) {
      setBrands(['KIWI', 'ELFBAR', 'RELX', 'WAKA', 'DINNER LADY 10000', 'FUYL 8000', 'VEEV', 'VUSE']);
    }
  }, []);

  const saveBrands = async (newBrands) => {
    setBrands(newBrands);
    try {
      await axios.put(`${API}/settings`, { footer_brands: newBrands });
    } catch (error) {
      console.error('Errore salvataggio brand footer:', error);
    }
  };

  useEffect(() => {
    loadBrands();
  }, [loadBrands]);

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3 className="footer-title">Tabaccheria N.16</h3>
            <p className="footer-description">
              Il tuo punto di riferimento a Reggio nell'Emilia per tabacchi, svapo e servizi al cittadino.
            </p>
            <div className="footer-contact">
              <div className="footer-contact-item">
                <MapPin className="w-4 h-4" />
                <span>{contactInfo.address}</span>
              </div>
              <div className="footer-contact-item">
                <Mail className="w-4 h-4" />
                <span>info@tabaccheria16reggio.it</span>
              </div>
            </div>
          </div>

          <div className="footer-section">
            <h4 className="footer-section-title">Prodotti Svapo</h4>
            <ul className="footer-links">
              {brands.map((brand) => (
                <li key={brand}>
                  <a href="#svapo">{brand}</a>
                </li>
              ))}
            </ul>
            {isEditMode && (
              <div data-testid="footer-brands-editor">
                <EditableList
                  items={brands}
                  onSave={saveBrands}
                  label="Lista Prodotti Svapo (footer)"
                />
              </div>
            )}
          </div>

          <div className="footer-section">
            <h4 className="footer-section-title">Servizi</h4>
            <ul className="footer-links">
              {services.map((service) => (
                service.items.map((item, idx) => (
                  <li key={`${service.id}-${idx}`}>
                    {isEditMode ? (
                      <div style={{ padding: '4px 0' }}>
                        <EditableText
                          value={item}
                          onSave={(val) => console.log('Servizio aggiornato:', val)}
                          label="Servizio"
                        />
                      </div>
                    ) : (
                      <a href="#services">{item}</a>
                    )}
                  </li>
                ))
              ))}
            </ul>
            {isEditMode && (
              <p style={{ 
                fontSize: '12px', 
                color: '#0891b2', 
                marginTop: '12px',
                fontStyle: 'italic'
              }}>
                💡 Per modificare i servizi, modifica mockData.js
              </p>
            )}
          </div>
        </div>

        <div className="footer-legal-section">
          <div className="footer-company-info">
            <p className="footer-company-name">Tabaccheria 16 Ditta individuale di Ji Giovanni</p>
            <p className="footer-company-details">
              Piazza Gioberti 4/B, angolo Via Emilia Santo Stefano 22/E, Reggio Emilia 42121 | P.IVA: 03116860358
            </p>
            <p className="footer-company-email">Email: info@tabaccheria16reggio.it</p>
          </div>
          
          <div className="footer-legal-links">
            <a href="https://www.iubenda.com/privacy-policy/84821434" className="iubenda-white iubenda-noiframe iubenda-embed footer-legal-link" title="Privacy Policy">Privacy Policy</a>
            <span className="footer-legal-separator">•</span>
            <a href="https://www.iubenda.com/privacy-policy/84821434/cookie-policy" className="iubenda-white iubenda-noiframe iubenda-embed footer-legal-link" title="Cookie Policy">Cookie Policy</a>
            <span className="footer-legal-separator">•</span>
            <a href="/termini-condizioni" className="footer-legal-link">Termini e Condizioni</a>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-copyright">
            © 2024 Tabaccheria N.16 - Reggio nell'Emilia. Tutti i diritti riservati.
          </p>
          <p className="footer-legal">
            La vendita di prodotti del tabacco e correlati è vietata ai minori di 18 anni
          </p>
        </div>
      </div>
    </footer>
  );
};

